import { MapContainer, TileLayer, useMap } from 'react-leaflet';
import { useEffect } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './MapComponent.css';
import PropTypes from 'prop-types';
import 'leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';

const customIcon = L.divIcon({
  className: 'custom-icon',
  html: '<div class="circle-icon"></div>',
  iconSize: [12, 12],
  iconAnchor: [6, 6],
  popupAnchor: [0, -6],
});

const DataFilterMap = ({ mapPoints }) => {

  const initialPosition = [37.8, -96];
 
  const USA_BOUNDS= [
    [24.396308, -125.0],  // South-West coordinates (latitude, longitude)
    [49.384358, -66.93457] // North-East coordinates (latitude, longitude)
  ];

  const ClusteredMarkers = () => {
    const map = useMap();

    useEffect(() => {
      const clusterGroup = L.markerClusterGroup();

      mapPoints?.forEach((marker) => {
        const newMarker = L.marker(marker.position, { icon: customIcon }).bindPopup(JSON.stringify(marker.data));
        clusterGroup?.addLayer(newMarker);
      });

      map.addLayer(clusterGroup);

      // Clean up on unmount
      return () => {
        map.removeLayer(clusterGroup);
      };
    }, [map]);

    return null; // This component doesn't render anything
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
      <MapContainer
        center={initialPosition}
        zoom={4}
        style={{ height: "50vh", width: "70%" }}
        zoomControl={false}
        bounds={USA_BOUNDS}
        boundsOptions={{ padding: [20, 20] }}
      >
        <TileLayer
          url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
        />
        <ClusteredMarkers />
      </MapContainer>
    </div>
  );
};


DataFilterMap.propTypes = {
  mapPoints: PropTypes.any, // Validate that data is a required array
};

export default DataFilterMap;
